/**
 * Barclay Engravers Theme JavaScript
 * Entry point for webpack bundling
 */

// Import vendor CSS from node_modules
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery-ui/dist/themes/base/jquery-ui.min.css';
import 'jquery-colorbox/example1/colorbox.css';

// Import compiled SCSS (our custom styles)
import '../scss/main.scss';

// Import vendor JS from node_modules
import 'jquery';
import 'bootstrap';
import 'jquery-ui/dist/jquery-ui.min.js';
import 'jquery-colorbox';

// Side Navigation
window.openNav = function() {
  "use strict";
  $("#sidenav").css("width", "300px");
  $("#main").css("marginLeft", "300px");
};

window.closeNav = function() {
  "use strict";
  $("#sidenav").css("width", "0px");
  $("#main").css("marginLeft", "0px");
};

$(document).ready(function() {
  "use strict";

  // Carousel Controls
  $('.carousel-control-prev').click(function() {
    $('#productSlide').carousel('prev');
  });

  $('.carousel-control-next').click(function() {
    $('#productSlide').carousel('next');
  });

  $('#LongCarousel').carousel({
    interval: 3000
  });

  // Initialize colorbox for product gallery photos
  $(".groupphoto").colorbox({ rel: 'groupphoto' });

  // Initialize colorbox for gallery page photos
  $(".gal").colorbox({ rel: 'gallery', maxWidth: '90%', maxHeight: '90%' });

  // Long Carousel Clone Items
  $('#LongCarousel.carousel .carousel-item').each(function() {
    var minPerSlide = 5;
    var next = $(this).next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    for (var i = 0; i < minPerSlide; i++) {
      next = next.next();
      if (!next.length) {
        next = $(this).siblings(':first');
      }
      next.children(':first-child').clone().appendTo($(this));
    }
  });

  // Slider Range Collision Detection
  function collision($div1, $div2) {
    var x1 = $div1.offset().left;
    var w1 = 40;
    var r1 = x1 + w1;
    var x2 = $div2.offset().left;
    var w2 = 40;
    var r2 = x2 + w2;

    if (r1 < x2 || x1 > r2) return false;
    return true;
  }

  // Price Range Slider
  $("#slider-range").slider({
    range: true,
    min: 1,
    max: $("#max").val(),
    step: 1,
    values: [0, $("#max").val()],
    slide: function(event, ui) {
      $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);

      $('.ui-slider-handle:eq(0) .price-range-min').html('$' + ui.values[0]);
      $('.ui-slider-handle:eq(1) .price-range-max').html('$' + ui.values[1]);
      $('.price-range-both').html('<i>$' + ui.values[0] + ' - </i>$' + ui.values[1]);

      if (ui.values[0] === ui.values[1]) {
        $('.price-range-both i').css('display', 'none');
      } else {
        $('.price-range-both i').css('display', 'inline');
      }

      if (collision($('.price-range-min'), $('.price-range-max')) === true) {
        $('.price-range-min, .price-range-max').css('opacity', '0');
        $('.price-range-both').css('display', 'block');
      } else {
        $('.price-range-min, .price-range-max').css('opacity', '1');
        $('.price-range-both').css('display', 'none');
      }
    }
  });

  $("#slider-range").slider('values', 0, $('#bottom').val());
  if ($('#top').val() < $("#max").val() && $('#top').val() !== '') {
    $("#slider-range").slider('values', 1, $('#top').val());
  } else {
    $("#slider-range").slider('values', 1, $("#max").val());
  }

  $('.ui-slider-range').append('<span class="price-range-both value"><i>$' + $('#slider-range').slider('values', 0) + ' - </i>' + $('#slider-range').slider('values', 1) + '</span>');
  $('.ui-slider-handle:eq(0)').append('<span class="price-range-min value">$' + $('#slider-range').slider('values', 0) + '</span>');
  $('.ui-slider-handle:eq(1)').append('<span class="price-range-max value">$' + $('#slider-range').slider('values', 1) + '</span>');

  $("#amount").val("$" + $("#slider-range").slider("values", 0) + " - $" + $("#slider-range").slider("values", 1));

  // Cart Calculator
  $("#relatedprice, #quantity, #ribbon").on("keyup keydown change", function() {
    $.ajax({
      url: 'home/calculate?id=' + $('#relatedprice').val() + '&qty=' + $('#quantity').val() + '&pro=1',
      success: function(response) {
        $('.total').html(response);
        $('.discount').hide();
        $('.discount-' + $('#relatedprice').val()).show();
        $('#addtoorder').attr('data-prodid', $('#relatedprice').val());
        if ($('#ribbon').length) {
          $('#addtoorder').attr('data-ribbonid', $('#ribbon').val());
        }
        $('#addtoorder').attr('data-prodqty', $('#quantity').val());
      },
      error: function() {
        $('.total').html('Error calculating price');
      }
    });
  });
  $("#quantity").trigger("change");

  // Quantity Buttons
  $(".quantity a").on("click", function() {
    var $button = $(this);
    var oldValue = $button.closest('.quantity').find("input").val();
    if (!$.isNumeric(oldValue)) {
      oldValue = 1;
    }
    var newVal = 1;
    if ($button.text() === "+") {
      newVal = parseFloat(oldValue) + 1;
    } else {
      if (oldValue > 2) {
        newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.closest('.quantity').find("input").val(newVal);
    $button.closest('.quantity').find("input").trigger('change');
    updateCart();
  });

  // Add to Cart
  $("#addtoorder").on("click", function() {
    if ($('#ribbon').length) {
      $.ajax({
        url: 'home/calculate?id=' + $('#ribbon').val() + '&qty=' + $('#quantity').val() + '&pro=2',
        error: function() {
          // Ribbon add failed silently
        }
      });
    }
    $.ajax({
      url: 'home/calculate?id=' + $('#relatedprice').val() + '&qty=' + $('#quantity').val() + '&pro=2',
      success: function(response) {
        $('.added').html(response);
        updateCart();
      },
      error: function() {
        $('.added').html('Error adding to cart. Please try again.');
      }
    });
  });

  // Update Cart Count
  function updateCart() {
    $.ajax({
      url: 'home/cartCount',
      success: function(response) {
        $('.cartcount').html(response);
      },
      error: function() {
        // Cart count update failed silently
      }
    });
  }

  // Remove from Cart
  $(".remove").on("click", function() {
    var id = $(this).data('id');
    $.ajax({
      url: 'home/calculate?id=' + id + '&qty=1&pro=4',
      success: function() {
        $('#product-' + id).remove();

        // Cart Total
        $.ajax({
          url: window.location.href + '/cartTotal',
          success: function(response) {
            $('.carttotal').html(response);
            updateCart();
          },
          error: function() {
            // Cart total update failed
          }
        });

        // Cart Tax
        $.ajax({
          url: window.location.href + '/cartTax',
          success: function(response) {
            $('.carttax').html('Total (incl ' + response + ' GST)');
          },
          error: function() {
            // Cart tax update failed
          }
        });
      },
      error: function() {
        alert('Error removing item from cart. Please try again.');
      }
    });
  });

  // Update Cart Quantity
  $(".qtyupdate").on("keyup keypress change", function() {
    var id = $(this).data('id');
    $.ajax({
      url: 'home/calculate?id=' + $(this).data('id') + '&qty=' + $(this).val() + '&pro=3',
      success: function(response) {
        try {
          var obj = JSON.parse(response);
          $('#product-' + id + ' .nameprice').html(obj.Name + ' @ ' + obj.Price);
          $('#product-' + id + ' .subtotal').html(obj.Total);
        } catch (e) {
          // Parse error - response may not be JSON
        }

        // Cart Total
        $.ajax({
          url: window.location.href + '/cartTotal',
          success: function(response) {
            $('.carttotal').html(response);
            updateCart();
          },
          error: function() {
            // Cart total update failed
          }
        });

        // Cart Tax
        $.ajax({
          url: window.location.href + '/cartTax',
          success: function(response) {
            $('.carttax').html('Total (incl ' + response + ' GST)');
          },
          error: function() {
            // Cart tax update failed
          }
        });
      },
      error: function() {
        // Cart update failed
      }
    });
  });
});
